/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ComponentBatchOperation = zod
	.object({
		action: zod.enum(['add', 'remove', 'update']),
		enabled: zod.boolean().optional(),
		policy_plan_id: zod.string().nullish(),
		policy_plan_version_id: zod.string().nullish(),
		position: zod.number().optional()
	})
	.describe('One component mutation operation');

export type ComponentBatchOperation = zod.input<typeof ComponentBatchOperation>;
export type ComponentBatchOperationOutput = zod.output<typeof ComponentBatchOperation>;
